import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import main from '@/components/main'
// 用户管理
import onlineUser from '@/components/views/user/onlineUserList'
import offlineUser from '@/components/views/user/offlineUserList'
// 文章管理
import aritcleList from '@/components/views/aritcle/aritcleList'
import aritcleAdd from '@/components/views/aritcle/aritcleAdd'
import aritcleEditor from '@/components/views/aritcle/aritcleEditor'
import aritcleTag from '@/components/views/aritcle/aritcleTagList'
import aritcleType from '@/components/views/aritcle/aritcleTypeList'
// 订单管理
import tempOrderList from '@/components/views/order/temp/tempOrderList'
import orderList from '@/components/views/order/orderAllList'
import orderAudit from '@/components/views/order/orderPendingAuditList'
import orderConsult from '@/components/views/order/orderConsultAllList'
// 发货管理.
import orderSendList from '@/components/views/order/orderDeliverGoodsList'
import orderSendOverList from '@/components/views/order/orderCompleteList'
// 线下订单
import contractList from '@/components/views/order/offline/contractList'
import offlineOrderList from '@/components/views/order/offline/orderList'
import offlineDeliverGoodsList from '@/components/views/order/offline/orderDeliverGoodsList'
import offlineCompleteGoodsList from '@/components/views/order/offline/orderCompleteList'
// 发票管理
import invoiceUnbilled from '@/components/views/invoice/invoiceUnbilledList'
import invoiceRecordList from '@/components/views/invoice/invoiceRecrodList'
import offlineInvoiceUnbilled from '@/components/views/invoice/offline/invoiceUnbilledList'
import offlineInvoiceRecordList from '@/components/views/invoice/offline/invoiceRecrodList'
import invoiceOfflineApply from '@/components/views/invoice/offline/invoiceApplyRecrodList'
import invoiceApply from '@/components/views/invoice/invoiceApplyRecrodList'
// 分类
import firstCategory from '@/components/views/category/firstCategory'
import firstCategoryEditor from '@/components/views/category/firstCategoryEditor'
import categoryList from '@/components/views/category/category'
import categoryEditor from '@/components/views/category/categoryEditor'
// 产品管理
import productList from '@/components/views/product/productList'
import productEditor from '@/components/views/product/productEditor'
// 品牌管理
import brandList from '@/components/views/brand/brandList'
import brandEditor from '@/components/views/brand/BrandEditor'
// 分站管理
import brandWebsite from '@/components/views/config/website'
// 友链管理
import skipList from '@/components/views/skip/skipList'
import skipAdd from '@/components/views/skip/skipAdd'
import skipEditor from '@/components/views/skip/skipEditor'
// 汇率管理
import excompanyList from '@/components/views/system/company/expressCompanyList'
import exchangeConfigList from '@/components/views/system/exchange/exchangeConfigList'
import exchangeConfigEditor from '@/components/views/system/exchange/exchangeConfigEditor'
// 供应商管理
import supplierList from '@/components/views/supplier/supplierList'
// 报表
import reportOrder from '@/components/views/home/reportOrder'
import reportUser from '@/components/views/home/reportUser'
// 待办事项
import tdlDetail from '@/components/views/home/tdlDetail'
// 搜索记录
import searchRecordList from '@/components/views/rsdata/searchRecordList'
// BOM
import bomSearch from '@/components/views/bom/bomList'

import productPurchaseList from '@/components/views/purchase/productPurchaseList'

// 退款管理
import refundOrderAudit from '@/components/views/refund/userOrderRefundAudit'
import userOrderRefundList from '@/components/views/refund/userOrderRefundList'

import offlineRefundOrderAudit from '@/components/views/refund/offline/userOrderRefundAudit'
import offlineUserOrderRefundList from '@/components/views/refund/offline/userOrderRefundList'


Vue.use(Router)

const originalPush = Router.prototype.push
  Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history',  //去掉url中的#
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/main',
      name: 'main',
      component: main,
      children: [
        {
          path: '/user/list',
          name: 'onlineUser',
          component: onlineUser,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        }, 
        {
          path: '/offline/user/list',
          name: 'offlineUser',
          component: offlineUser,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        }, 
        {
          path: '/article/list',
          name: 'aritcleList',
          component: aritcleList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        }, 
        {
          path: '/articleTag/list',
          name: 'aritcleTag',
          component: aritcleTag,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        }, 
        {
          path: '/articleType/list',
          name: 'aritcleType',
          component: aritcleType,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/aritcle/add',
          name: 'aritcleAdd',
          component: aritcleAdd,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/aritcle/editor',
          name: 'aritcleEditor',
          component: aritcleEditor,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/order/list',
          name: 'orderList',
          component: orderList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        }, 
        {
          path: '/order/consult/list',
          name: 'orderConsult',
          component: orderConsult,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        }, 
        {
          path: '/temp/order/list',
          name: 'tempOrderList',
          component: tempOrderList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        }, 
        {
          path: '/order/audit',
          name: 'orderAudit',
          component: orderAudit,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        },
        {
          path: '/order/send',
          name: 'orderSendList',
          component: orderSendList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        },
        {
          path: '/order/sendOver',
          name: 'orderSendOverList',
          component: orderSendOverList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        },
        {
          path: '/contract/list',
          name: 'contractList',
          component: contractList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        },
        {
          path: '/offline/order',
          name: 'offlineOrderList',
          component: offlineOrderList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        },
        {
          path: '/offline/deliver',
          name: 'offlineDeliverGoodsList',
          component: offlineDeliverGoodsList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        },
        {
          path: '/offline/order/complete',
          name: 'offlineCompleteGoodsList',
          component: offlineCompleteGoodsList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        },
        {
          path: '/brand/list',
          name: 'brandList',
          component: brandList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/brand/editor',
          name: 'brandEditor',
          component: brandEditor,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/website/list',
          name: 'brandWebsite',
          component: brandWebsite,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/product/list',
          name: 'productList',
          component: productList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/product/editor',
          name: 'productEditor',
          component: productEditor,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/skip/list',
          name: 'skipList',
          component: skipList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
          children: [
            
          ]
        },
        {
          path: '/skip/add',
          name: 'skipAdd',
          component: skipAdd,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/skip/editor',
          name: 'skipEditor',
          component: skipEditor,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/firstCategory/list',
          name: 'firstCategory',
          component: firstCategory,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        }, 
        {
          path: '/firstCategory/editor',
          name: 'firstCategoryEditor',
          component: firstCategoryEditor,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        }, 
        {
          path: '/category/list',
          name: 'categoryList',
          component: categoryList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/category/editor',
          name: 'categoryEditor',
          component: categoryEditor,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/excompany/list',
          name: 'excompanyList',
          component: excompanyList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        },
        {
          path: '/exchangeConfig/list',
          name: 'exchangeConfigList',
          component: exchangeConfigList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        },{
          path: '/exchangeConfig/editor',
          name: 'exchangeConfigEditor',
          component: exchangeConfigEditor,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        },
        {
          path: '/supplier/list',
          name: 'supplierList',
          component: supplierList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        },
        {
          path: '/invoice/unbilled',
          name: 'invoiceUnbilled',
          component: invoiceUnbilled,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        },
        {
          path: '/invoice/record/list',
          name: 'invoiceRecordList',
          component: invoiceRecordList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        },
        {
          path: '/invoice/offline/unbilled',
          name: 'offlineInvoiceUnbilled',
          component: offlineInvoiceUnbilled,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        },
        {
          path: '/invoice/offline/record/list',
          name: 'offlineInvoiceRecordList',
          component: offlineInvoiceRecordList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        }, 
        {
          path: '/invoice/offline/apply',
          name: 'invoiceOfflineApply',
          component: invoiceOfflineApply,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        },
        {
          path: '/invoice/apply',
          name: 'invoiceApply',
          component: invoiceApply,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        },   
        {
          path: '/search/record/list',
          name: 'searchRecordList',
          component: searchRecordList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        },
        {
          path: '/bom/list',
          name: 'bomSearch',
          component: bomSearch,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        },
        {
          path: '/purchase/search',
          name: 'productPurchaseList',
          component: productPurchaseList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        },
        {
          path: '/report/order',
          name: 'reportOrder',
          component: reportOrder,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        }, 
        {
          path: '/report/user',
          name: 'reportUser',
          component: reportUser,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        }, 
        {
          path: '/tdl/detail',
          name: 'tdlDetail',
          component: tdlDetail,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        }, 
        {
          path: '/order/refund/apply/list',
          name: 'refundOrderAudit',
          component: refundOrderAudit,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        },
        {
          path: '/order/refund/list',
          name: 'userOrderRefundList',
          component: userOrderRefundList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        }
        ,{
          path: '/offline/order/refund/apply/list',
          name: 'offlineRefundOrderAudit',
          component: offlineRefundOrderAudit,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        },
        {
          path: '/offline/order/refund/list',
          name: 'offlineUserOrderRefundList',
          component: offlineUserOrderRefundList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js